import script from "./MoneyReceipt.vue?vue&type=script&setup=true&lang=js"
export * from "./MoneyReceipt.vue?vue&type=script&setup=true&lang=js"

import "./MoneyReceipt.vue?vue&type=style&index=0&id=3dd1965e&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dd1965e"]])

export default __exports__